{
  "series": [
    {
      "id": "beneath-palm-shadows",
      "title": "Beneath Palm Shadows",
      "assetSlug": "BeneathPalmShadows",
      "genres": [
        "Drama",
        "Romance"
      ],
      "description": "A dream internship at a private island resort turns dangerous when an ambitious designer discovers that every luxury has a hidden owner.",
      "tagline": "Sun-drenched secrets. Dangerous desires. Every paradise has a price.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/BeneathPalmShadows_HERO.jpg",
      "cardImage": "/images/series/BeneathPalmShadows_CARD.jpg",
      "episodes": [
        {
          "id": "beneath-palm-shadows-s01e01",
          "number": 1,
          "season": 1,
          "title": "Welcome to Paradise",
          "durationSeconds": 83,
          "assetBase": "BeneathPalmShadows_S01E01",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E01.jpg",
          "video": "/videos/BeneathPalmShadows_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "beneath-palm-shadows-s01e02",
          "number": 2,
          "season": 1,
          "title": "Hidden Motives",
          "durationSeconds": 90,
          "assetBase": "BeneathPalmShadows_S01E02",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E02.jpg",
          "video": "/videos/BeneathPalmShadows_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "beneath-palm-shadows-s01e03",
          "number": 3,
          "season": 1,
          "title": "Lines We Don’t Cross",
          "durationSeconds": 63,
          "assetBase": "BeneathPalmShadows_S01E03",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E03.jpg",
          "video": "/videos/BeneathPalmShadows_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "beneath-palm-shadows-s01e04",
          "number": 4,
          "season": 1,
          "title": "The First Kiss",
          "durationSeconds": 70,
          "assetBase": "BeneathPalmShadows_S01E04",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E04.jpg",
          "video": "/videos/BeneathPalmShadows_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "beneath-palm-shadows-s01e05",
          "number": 5,
          "season": 1,
          "title": "Cracks in the Perfect Life",
          "durationSeconds": 77,
          "assetBase": "BeneathPalmShadows_S01E05",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E05.jpg",
          "video": "/videos/BeneathPalmShadows_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "beneath-palm-shadows-s01e06",
          "number": 6,
          "season": 1,
          "title": "Truth in the Shadows",
          "durationSeconds": 84,
          "assetBase": "BeneathPalmShadows_S01E06",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E06.jpg",
          "video": "/videos/BeneathPalmShadows_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "beneath-palm-shadows-s01e07",
          "number": 7,
          "season": 1,
          "title": "The Choice",
          "durationSeconds": 91,
          "assetBase": "BeneathPalmShadows_S01E07",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E07.jpg",
          "video": "/videos/BeneathPalmShadows_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "beneath-palm-shadows-s01e08",
          "number": 8,
          "season": 1,
          "title": "No Safe Harbour",
          "durationSeconds": 64,
          "assetBase": "BeneathPalmShadows_S01E08",
          "thumbnail": "/images/episodes/BeneathPalmShadows_S01E08.jpg",
          "video": "/videos/BeneathPalmShadows_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "heir-to-my-heart",
      "title": "Heir to My Heart",
      "assetSlug": "HeirToMyHeart",
      "genres": [
        "Romance",
        "Drama"
      ],
      "description": "A principled lawyer is forced to defend the heir she once loved—and uncovers the family secret that ended their relationship.",
      "tagline": "He has the empire. She has the evidence.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/HeirToMyHeart_HERO.jpg",
      "cardImage": "/images/series/HeirToMyHeart_CARD.jpg",
      "episodes": [
        {
          "id": "heir-to-my-heart-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Summons",
          "durationSeconds": 78,
          "assetBase": "HeirToMyHeart_S01E01",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E01.jpg",
          "video": "/videos/HeirToMyHeart_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "heir-to-my-heart-s01e02",
          "number": 2,
          "season": 1,
          "title": "A Familiar Enemy",
          "durationSeconds": 85,
          "assetBase": "HeirToMyHeart_S01E02",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E02.jpg",
          "video": "/videos/HeirToMyHeart_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "heir-to-my-heart-s01e03",
          "number": 3,
          "season": 1,
          "title": "Terms of Defence",
          "durationSeconds": 58,
          "assetBase": "HeirToMyHeart_S01E03",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E03.jpg",
          "video": "/videos/HeirToMyHeart_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "heir-to-my-heart-s01e04",
          "number": 4,
          "season": 1,
          "title": "The Family Table",
          "durationSeconds": 65,
          "assetBase": "HeirToMyHeart_S01E04",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E04.jpg",
          "video": "/videos/HeirToMyHeart_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "heir-to-my-heart-s01e05",
          "number": 5,
          "season": 1,
          "title": "A Missing Signature",
          "durationSeconds": 72,
          "assetBase": "HeirToMyHeart_S01E05",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E05.jpg",
          "video": "/videos/HeirToMyHeart_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "heir-to-my-heart-s01e06",
          "number": 6,
          "season": 1,
          "title": "Old Promises",
          "durationSeconds": 79,
          "assetBase": "HeirToMyHeart_S01E06",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E06.jpg",
          "video": "/videos/HeirToMyHeart_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "heir-to-my-heart-s01e07",
          "number": 7,
          "season": 1,
          "title": "The Witness",
          "durationSeconds": 86,
          "assetBase": "HeirToMyHeart_S01E07",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E07.jpg",
          "video": "/videos/HeirToMyHeart_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "heir-to-my-heart-s01e08",
          "number": 8,
          "season": 1,
          "title": "Judgement Day",
          "durationSeconds": 59,
          "assetBase": "HeirToMyHeart_S01E08",
          "thumbnail": "/images/episodes/HeirToMyHeart_S01E08.jpg",
          "video": "/videos/HeirToMyHeart_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "the-alphas-claim",
      "title": "The Alpha's Claim",
      "assetSlug": "TheAlphasClaim",
      "genres": [
        "Supernatural",
        "Romance"
      ],
      "description": "A wildlife veterinarian rescues an injured stranger and becomes entangled in a hidden dynasty divided by blood and loyalty.",
      "tagline": "Some bonds are older than memory.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 6,
      "heroImage": "/images/series/TheAlphasClaim_HERO.jpg",
      "cardImage": "/images/series/TheAlphasClaim_CARD.jpg",
      "episodes": [
        {
          "id": "the-alphas-claim-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Rescue",
          "durationSeconds": 79,
          "assetBase": "TheAlphasClaim_S01E01",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E01.jpg",
          "video": "/videos/TheAlphasClaim_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-alphas-claim-s01e02",
          "number": 2,
          "season": 1,
          "title": "The Mark",
          "durationSeconds": 86,
          "assetBase": "TheAlphasClaim_S01E02",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E02.jpg",
          "video": "/videos/TheAlphasClaim_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-alphas-claim-s01e03",
          "number": 3,
          "season": 1,
          "title": "Moonlit Warning",
          "durationSeconds": 59,
          "assetBase": "TheAlphasClaim_S01E03",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E03.jpg",
          "video": "/videos/TheAlphasClaim_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-alphas-claim-s01e04",
          "number": 4,
          "season": 1,
          "title": "A Debt of Blood",
          "durationSeconds": 66,
          "assetBase": "TheAlphasClaim_S01E04",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E04.jpg",
          "video": "/videos/TheAlphasClaim_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-alphas-claim-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Pack Divides",
          "durationSeconds": 73,
          "assetBase": "TheAlphasClaim_S01E05",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E05.jpg",
          "video": "/videos/TheAlphasClaim_S01E05.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "the-alphas-claim-s01e06",
          "number": 6,
          "season": 1,
          "title": "The Hunter Arrives",
          "durationSeconds": 80,
          "assetBase": "TheAlphasClaim_S01E06",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E06.jpg",
          "video": "/videos/TheAlphasClaim_S01E06.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "the-alphas-claim-s01e07",
          "number": 7,
          "season": 1,
          "title": "Claim or Choice",
          "durationSeconds": 87,
          "assetBase": "TheAlphasClaim_S01E07",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E07.jpg",
          "video": "/videos/TheAlphasClaim_S01E07.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "the-alphas-claim-s01e08",
          "number": 8,
          "season": 1,
          "title": "Before Dawn",
          "durationSeconds": 60,
          "assetBase": "TheAlphasClaim_S01E08",
          "thumbnail": "/images/episodes/TheAlphasClaim_S01E08.jpg",
          "video": "/videos/TheAlphasClaim_S01E08.mp4",
          "free": false,
          "diamondCost": 6
        }
      ]
    },
    {
      "id": "cyber-veil",
      "title": "Cyber Veil",
      "assetSlug": "CyberVeil",
      "genres": [
        "Science Fiction",
        "Thriller"
      ],
      "description": "A memory engineer discovers that her own past has been edited—and that the corporation responsible is watching her reconstruct it.",
      "tagline": "Your memories are not your own.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 6,
      "heroImage": "/images/series/CyberVeil_HERO.jpg",
      "cardImage": "/images/series/CyberVeil_CARD.jpg",
      "episodes": [
        {
          "id": "cyber-veil-s01e01",
          "number": 1,
          "season": 1,
          "title": "Memory Zero",
          "durationSeconds": 74,
          "assetBase": "CyberVeil_S01E01",
          "thumbnail": "/images/episodes/CyberVeil_S01E01.jpg",
          "video": "/videos/CyberVeil_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "cyber-veil-s01e02",
          "number": 2,
          "season": 1,
          "title": "The False Childhood",
          "durationSeconds": 81,
          "assetBase": "CyberVeil_S01E02",
          "thumbnail": "/images/episodes/CyberVeil_S01E02.jpg",
          "video": "/videos/CyberVeil_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "cyber-veil-s01e03",
          "number": 3,
          "season": 1,
          "title": "Ghost Process",
          "durationSeconds": 88,
          "assetBase": "CyberVeil_S01E03",
          "thumbnail": "/images/episodes/CyberVeil_S01E03.jpg",
          "video": "/videos/CyberVeil_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "cyber-veil-s01e04",
          "number": 4,
          "season": 1,
          "title": "The Woman in Glass",
          "durationSeconds": 61,
          "assetBase": "CyberVeil_S01E04",
          "thumbnail": "/images/episodes/CyberVeil_S01E04.jpg",
          "video": "/videos/CyberVeil_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "cyber-veil-s01e05",
          "number": 5,
          "season": 1,
          "title": "Root Access",
          "durationSeconds": 68,
          "assetBase": "CyberVeil_S01E05",
          "thumbnail": "/images/episodes/CyberVeil_S01E05.jpg",
          "video": "/videos/CyberVeil_S01E05.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "cyber-veil-s01e06",
          "number": 6,
          "season": 1,
          "title": "The Other Me",
          "durationSeconds": 75,
          "assetBase": "CyberVeil_S01E06",
          "thumbnail": "/images/episodes/CyberVeil_S01E06.jpg",
          "video": "/videos/CyberVeil_S01E06.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "cyber-veil-s01e07",
          "number": 7,
          "season": 1,
          "title": "System Collapse",
          "durationSeconds": 82,
          "assetBase": "CyberVeil_S01E07",
          "thumbnail": "/images/episodes/CyberVeil_S01E07.jpg",
          "video": "/videos/CyberVeil_S01E07.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "cyber-veil-s01e08",
          "number": 8,
          "season": 1,
          "title": "Original Copy",
          "durationSeconds": 89,
          "assetBase": "CyberVeil_S01E08",
          "thumbnail": "/images/episodes/CyberVeil_S01E08.jpg",
          "video": "/videos/CyberVeil_S01E08.mp4",
          "free": false,
          "diamondCost": 6
        }
      ]
    },
    {
      "id": "shadow-protocol",
      "title": "Shadow Protocol",
      "assetSlug": "ShadowProtocol",
      "genres": [
        "Action",
        "Thriller"
      ],
      "description": "A disgraced field operative has one night to stop an attack designed by the mentor who trained him.",
      "tagline": "Trust no order. Follow no shadow.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 6,
      "heroImage": "/images/series/ShadowProtocol_HERO.jpg",
      "cardImage": "/images/series/ShadowProtocol_CARD.jpg",
      "episodes": [
        {
          "id": "shadow-protocol-s01e01",
          "number": 1,
          "season": 1,
          "title": "Extraction",
          "durationSeconds": 79,
          "assetBase": "ShadowProtocol_S01E01",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E01.jpg",
          "video": "/videos/ShadowProtocol_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "shadow-protocol-s01e02",
          "number": 2,
          "season": 1,
          "title": "Dead Channel",
          "durationSeconds": 86,
          "assetBase": "ShadowProtocol_S01E02",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E02.jpg",
          "video": "/videos/ShadowProtocol_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "shadow-protocol-s01e03",
          "number": 3,
          "season": 1,
          "title": "The Safe House",
          "durationSeconds": 59,
          "assetBase": "ShadowProtocol_S01E03",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E03.jpg",
          "video": "/videos/ShadowProtocol_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "shadow-protocol-s01e04",
          "number": 4,
          "season": 1,
          "title": "No Command",
          "durationSeconds": 66,
          "assetBase": "ShadowProtocol_S01E04",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E04.jpg",
          "video": "/videos/ShadowProtocol_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "shadow-protocol-s01e05",
          "number": 5,
          "season": 1,
          "title": "Friendly Fire",
          "durationSeconds": 73,
          "assetBase": "ShadowProtocol_S01E05",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E05.jpg",
          "video": "/videos/ShadowProtocol_S01E05.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "shadow-protocol-s01e06",
          "number": 6,
          "season": 1,
          "title": "Target Alpha",
          "durationSeconds": 80,
          "assetBase": "ShadowProtocol_S01E06",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E06.jpg",
          "video": "/videos/ShadowProtocol_S01E06.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "shadow-protocol-s01e07",
          "number": 7,
          "season": 1,
          "title": "The Mentor",
          "durationSeconds": 87,
          "assetBase": "ShadowProtocol_S01E07",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E07.jpg",
          "video": "/videos/ShadowProtocol_S01E07.mp4",
          "free": false,
          "diamondCost": 6
        },
        {
          "id": "shadow-protocol-s01e08",
          "number": 8,
          "season": 1,
          "title": "Last Light",
          "durationSeconds": 60,
          "assetBase": "ShadowProtocol_S01E08",
          "thumbnail": "/images/episodes/ShadowProtocol_S01E08.jpg",
          "video": "/videos/ShadowProtocol_S01E08.mp4",
          "free": false,
          "diamondCost": 6
        }
      ]
    },
    {
      "id": "blood-moon-rising",
      "title": "Blood Moon Rising",
      "assetSlug": "BloodMoonRising",
      "genres": [
        "Horror",
        "Mystery"
      ],
      "description": "A coastal town celebrates a festival that occurs once every thirty years. This time, the missing return home.",
      "tagline": "The tide remembers every name.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/BloodMoonRising_HERO.jpg",
      "cardImage": "/images/series/BloodMoonRising_CARD.jpg",
      "episodes": [
        {
          "id": "blood-moon-rising-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Festival",
          "durationSeconds": 80,
          "assetBase": "BloodMoonRising_S01E01",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E01.jpg",
          "video": "/videos/BloodMoonRising_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "blood-moon-rising-s01e02",
          "number": 2,
          "season": 1,
          "title": "A Face at the Window",
          "durationSeconds": 87,
          "assetBase": "BloodMoonRising_S01E02",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E02.jpg",
          "video": "/videos/BloodMoonRising_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "blood-moon-rising-s01e03",
          "number": 3,
          "season": 1,
          "title": "Low Tide",
          "durationSeconds": 60,
          "assetBase": "BloodMoonRising_S01E03",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E03.jpg",
          "video": "/videos/BloodMoonRising_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "blood-moon-rising-s01e04",
          "number": 4,
          "season": 1,
          "title": "The Bell Below",
          "durationSeconds": 67,
          "assetBase": "BloodMoonRising_S01E04",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E04.jpg",
          "video": "/videos/BloodMoonRising_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "blood-moon-rising-s01e05",
          "number": 5,
          "season": 1,
          "title": "Names in Salt",
          "durationSeconds": 74,
          "assetBase": "BloodMoonRising_S01E05",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E05.jpg",
          "video": "/videos/BloodMoonRising_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "blood-moon-rising-s01e06",
          "number": 6,
          "season": 1,
          "title": "The Returned",
          "durationSeconds": 81,
          "assetBase": "BloodMoonRising_S01E06",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E06.jpg",
          "video": "/videos/BloodMoonRising_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "blood-moon-rising-s01e07",
          "number": 7,
          "season": 1,
          "title": "Red Water",
          "durationSeconds": 88,
          "assetBase": "BloodMoonRising_S01E07",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E07.jpg",
          "video": "/videos/BloodMoonRising_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "blood-moon-rising-s01e08",
          "number": 8,
          "season": 1,
          "title": "Morning Never Came",
          "durationSeconds": 61,
          "assetBase": "BloodMoonRising_S01E08",
          "thumbnail": "/images/episodes/BloodMoonRising_S01E08.jpg",
          "video": "/videos/BloodMoonRising_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "secrets-of-the-ceo",
      "title": "Secrets of the CEO",
      "assetSlug": "SecretsOfTheCEO",
      "genres": [
        "Telenovela",
        "Romance"
      ],
      "description": "A junior strategist enters a contract engagement with her ruthless CEO and quickly learns the arrangement was never about appearances.",
      "tagline": "The deal was simple. The feelings were not.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/SecretsOfTheCEO_HERO.jpg",
      "cardImage": "/images/series/SecretsOfTheCEO_CARD.jpg",
      "episodes": [
        {
          "id": "secrets-of-the-ceo-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Contract",
          "durationSeconds": 80,
          "assetBase": "SecretsOfTheCEO_S01E01",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E01.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "secrets-of-the-ceo-s01e02",
          "number": 2,
          "season": 1,
          "title": "Public Display",
          "durationSeconds": 87,
          "assetBase": "SecretsOfTheCEO_S01E02",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E02.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "secrets-of-the-ceo-s01e03",
          "number": 3,
          "season": 1,
          "title": "Private Terms",
          "durationSeconds": 60,
          "assetBase": "SecretsOfTheCEO_S01E03",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E03.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "secrets-of-the-ceo-s01e04",
          "number": 4,
          "season": 1,
          "title": "Elevator Silence",
          "durationSeconds": 67,
          "assetBase": "SecretsOfTheCEO_S01E04",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E04.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "secrets-of-the-ceo-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Ex Returns",
          "durationSeconds": 74,
          "assetBase": "SecretsOfTheCEO_S01E05",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E05.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "secrets-of-the-ceo-s01e06",
          "number": 6,
          "season": 1,
          "title": "Boardroom Betrayal",
          "durationSeconds": 81,
          "assetBase": "SecretsOfTheCEO_S01E06",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E06.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "secrets-of-the-ceo-s01e07",
          "number": 7,
          "season": 1,
          "title": "The Real Clause",
          "durationSeconds": 88,
          "assetBase": "SecretsOfTheCEO_S01E07",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E07.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "secrets-of-the-ceo-s01e08",
          "number": 8,
          "season": 1,
          "title": "No More Pretending",
          "durationSeconds": 61,
          "assetBase": "SecretsOfTheCEO_S01E08",
          "thumbnail": "/images/episodes/SecretsOfTheCEO_S01E08.jpg",
          "video": "/videos/SecretsOfTheCEO_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "the-wrong-bride",
      "title": "The Wrong Bride",
      "assetSlug": "TheWrongBride",
      "genres": [
        "Telenovela",
        "Drama"
      ],
      "description": "A last-minute substitution at an elite wedding places two sisters on opposite sides of a family war.",
      "tagline": "One ceremony. Two destinies.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/TheWrongBride_HERO.jpg",
      "cardImage": "/images/series/TheWrongBride_CARD.jpg",
      "episodes": [
        {
          "id": "the-wrong-bride-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Switch",
          "durationSeconds": 78,
          "assetBase": "TheWrongBride_S01E01",
          "thumbnail": "/images/episodes/TheWrongBride_S01E01.jpg",
          "video": "/videos/TheWrongBride_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-wrong-bride-s01e02",
          "number": 2,
          "season": 1,
          "title": "A Veil of Lies",
          "durationSeconds": 85,
          "assetBase": "TheWrongBride_S01E02",
          "thumbnail": "/images/episodes/TheWrongBride_S01E02.jpg",
          "video": "/videos/TheWrongBride_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-wrong-bride-s01e03",
          "number": 3,
          "season": 1,
          "title": "The Groom Knows",
          "durationSeconds": 58,
          "assetBase": "TheWrongBride_S01E03",
          "thumbnail": "/images/episodes/TheWrongBride_S01E03.jpg",
          "video": "/videos/TheWrongBride_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-wrong-bride-s01e04",
          "number": 4,
          "season": 1,
          "title": "Sister’s Debt",
          "durationSeconds": 65,
          "assetBase": "TheWrongBride_S01E04",
          "thumbnail": "/images/episodes/TheWrongBride_S01E04.jpg",
          "video": "/videos/TheWrongBride_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-wrong-bride-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Family Ledger",
          "durationSeconds": 72,
          "assetBase": "TheWrongBride_S01E05",
          "thumbnail": "/images/episodes/TheWrongBride_S01E05.jpg",
          "video": "/videos/TheWrongBride_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-wrong-bride-s01e06",
          "number": 6,
          "season": 1,
          "title": "Runaway Truth",
          "durationSeconds": 79,
          "assetBase": "TheWrongBride_S01E06",
          "thumbnail": "/images/episodes/TheWrongBride_S01E06.jpg",
          "video": "/videos/TheWrongBride_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-wrong-bride-s01e07",
          "number": 7,
          "season": 1,
          "title": "The Second Ceremony",
          "durationSeconds": 86,
          "assetBase": "TheWrongBride_S01E07",
          "thumbnail": "/images/episodes/TheWrongBride_S01E07.jpg",
          "video": "/videos/TheWrongBride_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-wrong-bride-s01e08",
          "number": 8,
          "season": 1,
          "title": "Choose Me",
          "durationSeconds": 59,
          "assetBase": "TheWrongBride_S01E08",
          "thumbnail": "/images/episodes/TheWrongBride_S01E08.jpg",
          "video": "/videos/TheWrongBride_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "the-billionaires-bet",
      "title": "The Billionaire's Bet",
      "assetSlug": "TheBillionairesBet",
      "genres": [
        "Romance",
        "Drama"
      ],
      "description": "A billionaire wagers he can transform a struggling hotel in thirty days—without revealing that the owner is the woman he abandoned.",
      "tagline": "He risked a fortune. She risked nothing.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/TheBillionairesBet_HERO.jpg",
      "cardImage": "/images/series/TheBillionairesBet_CARD.jpg",
      "episodes": [
        {
          "id": "the-billionaires-bet-s01e01",
          "number": 1,
          "season": 1,
          "title": "Thirty Days",
          "durationSeconds": 83,
          "assetBase": "TheBillionairesBet_S01E01",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E01.jpg",
          "video": "/videos/TheBillionairesBet_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-billionaires-bet-s01e02",
          "number": 2,
          "season": 1,
          "title": "The Old Lobby",
          "durationSeconds": 90,
          "assetBase": "TheBillionairesBet_S01E02",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E02.jpg",
          "video": "/videos/TheBillionairesBet_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-billionaires-bet-s01e03",
          "number": 3,
          "season": 1,
          "title": "Hidden Investor",
          "durationSeconds": 63,
          "assetBase": "TheBillionairesBet_S01E03",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E03.jpg",
          "video": "/videos/TheBillionairesBet_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-billionaires-bet-s01e04",
          "number": 4,
          "season": 1,
          "title": "Suite 17",
          "durationSeconds": 70,
          "assetBase": "TheBillionairesBet_S01E04",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E04.jpg",
          "video": "/videos/TheBillionairesBet_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "the-billionaires-bet-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Rival Bid",
          "durationSeconds": 77,
          "assetBase": "TheBillionairesBet_S01E05",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E05.jpg",
          "video": "/videos/TheBillionairesBet_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-billionaires-bet-s01e06",
          "number": 6,
          "season": 1,
          "title": "What He Owes",
          "durationSeconds": 84,
          "assetBase": "TheBillionairesBet_S01E06",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E06.jpg",
          "video": "/videos/TheBillionairesBet_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-billionaires-bet-s01e07",
          "number": 7,
          "season": 1,
          "title": "Opening Night",
          "durationSeconds": 91,
          "assetBase": "TheBillionairesBet_S01E07",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E07.jpg",
          "video": "/videos/TheBillionairesBet_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "the-billionaires-bet-s01e08",
          "number": 8,
          "season": 1,
          "title": "No More Bets",
          "durationSeconds": 64,
          "assetBase": "TheBillionairesBet_S01E08",
          "thumbnail": "/images/episodes/TheBillionairesBet_S01E08.jpg",
          "video": "/videos/TheBillionairesBet_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "falling-for-my-rival",
      "title": "Falling for My Rival",
      "assetSlug": "FallingForMyRival",
      "genres": [
        "Romance",
        "Comedy"
      ],
      "description": "Competing architects are forced to share a villa while pitching for the same career-defining project.",
      "tagline": "Winning is easy. Living together is not.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 5,
      "heroImage": "/images/series/FallingForMyRival_HERO.jpg",
      "cardImage": "/images/series/FallingForMyRival_CARD.jpg",
      "episodes": [
        {
          "id": "falling-for-my-rival-s01e01",
          "number": 1,
          "season": 1,
          "title": "Shared Keys",
          "durationSeconds": 82,
          "assetBase": "FallingForMyRival_S01E01",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E01.jpg",
          "video": "/videos/FallingForMyRival_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "falling-for-my-rival-s01e02",
          "number": 2,
          "season": 1,
          "title": "The First Sketch",
          "durationSeconds": 89,
          "assetBase": "FallingForMyRival_S01E02",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E02.jpg",
          "video": "/videos/FallingForMyRival_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "falling-for-my-rival-s01e03",
          "number": 3,
          "season": 1,
          "title": "Poolside Truce",
          "durationSeconds": 62,
          "assetBase": "FallingForMyRival_S01E03",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E03.jpg",
          "video": "/videos/FallingForMyRival_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "falling-for-my-rival-s01e04",
          "number": 4,
          "season": 1,
          "title": "One Bedroom Left",
          "durationSeconds": 69,
          "assetBase": "FallingForMyRival_S01E04",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E04.jpg",
          "video": "/videos/FallingForMyRival_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "falling-for-my-rival-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Stolen Pitch",
          "durationSeconds": 76,
          "assetBase": "FallingForMyRival_S01E05",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E05.jpg",
          "video": "/videos/FallingForMyRival_S01E05.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "falling-for-my-rival-s01e06",
          "number": 6,
          "season": 1,
          "title": "Storm Warning",
          "durationSeconds": 83,
          "assetBase": "FallingForMyRival_S01E06",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E06.jpg",
          "video": "/videos/FallingForMyRival_S01E06.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "falling-for-my-rival-s01e07",
          "number": 7,
          "season": 1,
          "title": "Final Presentation",
          "durationSeconds": 90,
          "assetBase": "FallingForMyRival_S01E07",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E07.jpg",
          "video": "/videos/FallingForMyRival_S01E07.mp4",
          "free": false,
          "diamondCost": 5
        },
        {
          "id": "falling-for-my-rival-s01e08",
          "number": 8,
          "season": 1,
          "title": "Built Together",
          "durationSeconds": 63,
          "assetBase": "FallingForMyRival_S01E08",
          "thumbnail": "/images/episodes/FallingForMyRival_S01E08.jpg",
          "video": "/videos/FallingForMyRival_S01E08.mp4",
          "free": false,
          "diamondCost": 5
        }
      ]
    },
    {
      "id": "chameleons-masters-of-change",
      "title": "Chameleons: Masters of Change",
      "assetSlug": "ChameleonsMastersOfChange",
      "genres": [
        "Documentary",
        "Nature"
      ],
      "description": "A vivid close-up journey into the evolution, communication and survival strategies of the world’s most adaptable reptiles.",
      "tagline": "Colour is only the beginning.",
      "year": 2026,
      "featured": true,
      "freeEpisodeCount": 4,
      "diamondCost": 4,
      "heroImage": "/images/series/ChameleonsMastersOfChange_HERO.jpg",
      "cardImage": "/images/series/ChameleonsMastersOfChange_CARD.jpg",
      "episodes": [
        {
          "id": "chameleons-masters-of-change-s01e01",
          "number": 1,
          "season": 1,
          "title": "Living Colour",
          "durationSeconds": 90,
          "assetBase": "ChameleonsMastersOfChange_S01E01",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E01.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "chameleons-masters-of-change-s01e02",
          "number": 2,
          "season": 1,
          "title": "Eyes Everywhere",
          "durationSeconds": 63,
          "assetBase": "ChameleonsMastersOfChange_S01E02",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E02.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "chameleons-masters-of-change-s01e03",
          "number": 3,
          "season": 1,
          "title": "The Language of Skin",
          "durationSeconds": 70,
          "assetBase": "ChameleonsMastersOfChange_S01E03",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E03.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "chameleons-masters-of-change-s01e04",
          "number": 4,
          "season": 1,
          "title": "Born to Climb",
          "durationSeconds": 77,
          "assetBase": "ChameleonsMastersOfChange_S01E04",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E04.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "chameleons-masters-of-change-s01e05",
          "number": 5,
          "season": 1,
          "title": "Island Giants",
          "durationSeconds": 84,
          "assetBase": "ChameleonsMastersOfChange_S01E05",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E05.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E05.mp4",
          "free": false,
          "diamondCost": 4
        },
        {
          "id": "chameleons-masters-of-change-s01e06",
          "number": 6,
          "season": 1,
          "title": "Survival in Slow Motion",
          "durationSeconds": 91,
          "assetBase": "ChameleonsMastersOfChange_S01E06",
          "thumbnail": "/images/episodes/ChameleonsMastersOfChange_S01E06.jpg",
          "video": "/videos/ChameleonsMastersOfChange_S01E06.mp4",
          "free": false,
          "diamondCost": 4
        }
      ]
    },
    {
      "id": "deep-ocean-secrets",
      "title": "Deep Ocean Secrets",
      "assetSlug": "DeepOceanSecrets",
      "genres": [
        "Documentary",
        "Nature"
      ],
      "description": "New imaging technology reveals communities thriving in the darkest and least explored parts of Earth’s oceans.",
      "tagline": "Below the light, another world begins.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 4,
      "heroImage": "/images/series/DeepOceanSecrets_HERO.jpg",
      "cardImage": "/images/series/DeepOceanSecrets_CARD.jpg",
      "episodes": [
        {
          "id": "deep-ocean-secrets-s01e01",
          "number": 1,
          "season": 1,
          "title": "Into the Black",
          "durationSeconds": 81,
          "assetBase": "DeepOceanSecrets_S01E01",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E01.jpg",
          "video": "/videos/DeepOceanSecrets_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "deep-ocean-secrets-s01e02",
          "number": 2,
          "season": 1,
          "title": "Cities of Coral",
          "durationSeconds": 88,
          "assetBase": "DeepOceanSecrets_S01E02",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E02.jpg",
          "video": "/videos/DeepOceanSecrets_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "deep-ocean-secrets-s01e03",
          "number": 3,
          "season": 1,
          "title": "The Living Lights",
          "durationSeconds": 61,
          "assetBase": "DeepOceanSecrets_S01E03",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E03.jpg",
          "video": "/videos/DeepOceanSecrets_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "deep-ocean-secrets-s01e04",
          "number": 4,
          "season": 1,
          "title": "Giants Below",
          "durationSeconds": 68,
          "assetBase": "DeepOceanSecrets_S01E04",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E04.jpg",
          "video": "/videos/DeepOceanSecrets_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "deep-ocean-secrets-s01e05",
          "number": 5,
          "season": 1,
          "title": "Volcanic Gardens",
          "durationSeconds": 75,
          "assetBase": "DeepOceanSecrets_S01E05",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E05.jpg",
          "video": "/videos/DeepOceanSecrets_S01E05.mp4",
          "free": false,
          "diamondCost": 4
        },
        {
          "id": "deep-ocean-secrets-s01e06",
          "number": 6,
          "season": 1,
          "title": "The Last Frontier",
          "durationSeconds": 82,
          "assetBase": "DeepOceanSecrets_S01E06",
          "thumbnail": "/images/episodes/DeepOceanSecrets_S01E06.jpg",
          "video": "/videos/DeepOceanSecrets_S01E06.mp4",
          "free": false,
          "diamondCost": 4
        }
      ]
    },
    {
      "id": "wild-africa",
      "title": "Wild Africa",
      "assetSlug": "WildAfrica",
      "genres": [
        "Documentary",
        "Nature"
      ],
      "description": "Across savannah, desert and forest, animal families navigate drought, migration and sudden abundance.",
      "tagline": "A continent in constant motion.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 4,
      "heroImage": "/images/series/WildAfrica_HERO.jpg",
      "cardImage": "/images/series/WildAfrica_CARD.jpg",
      "episodes": [
        {
          "id": "wild-africa-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Long Rains",
          "durationSeconds": 75,
          "assetBase": "WildAfrica_S01E01",
          "thumbnail": "/images/episodes/WildAfrica_S01E01.jpg",
          "video": "/videos/WildAfrica_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "wild-africa-s01e02",
          "number": 2,
          "season": 1,
          "title": "Families of the Plains",
          "durationSeconds": 82,
          "assetBase": "WildAfrica_S01E02",
          "thumbnail": "/images/episodes/WildAfrica_S01E02.jpg",
          "video": "/videos/WildAfrica_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "wild-africa-s01e03",
          "number": 3,
          "season": 1,
          "title": "Desert Survivors",
          "durationSeconds": 89,
          "assetBase": "WildAfrica_S01E03",
          "thumbnail": "/images/episodes/WildAfrica_S01E03.jpg",
          "video": "/videos/WildAfrica_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "wild-africa-s01e04",
          "number": 4,
          "season": 1,
          "title": "River Kingdoms",
          "durationSeconds": 62,
          "assetBase": "WildAfrica_S01E04",
          "thumbnail": "/images/episodes/WildAfrica_S01E04.jpg",
          "video": "/videos/WildAfrica_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "wild-africa-s01e05",
          "number": 5,
          "season": 1,
          "title": "Night Hunters",
          "durationSeconds": 69,
          "assetBase": "WildAfrica_S01E05",
          "thumbnail": "/images/episodes/WildAfrica_S01E05.jpg",
          "video": "/videos/WildAfrica_S01E05.mp4",
          "free": false,
          "diamondCost": 4
        },
        {
          "id": "wild-africa-s01e06",
          "number": 6,
          "season": 1,
          "title": "The Great Return",
          "durationSeconds": 76,
          "assetBase": "WildAfrica_S01E06",
          "thumbnail": "/images/episodes/WildAfrica_S01E06.jpg",
          "video": "/videos/WildAfrica_S01E06.mp4",
          "free": false,
          "diamondCost": 4
        }
      ]
    },
    {
      "id": "inside-the-ancient-world",
      "title": "Inside the Ancient World",
      "assetSlug": "InsideTheAncientWorld",
      "genres": [
        "Documentary",
        "History"
      ],
      "description": "Archaeologists reconstruct the engineering, trade and private lives behind the monuments that shaped civilisation.",
      "tagline": "The stones survived. Their stories almost did not.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 4,
      "heroImage": "/images/series/InsideTheAncientWorld_HERO.jpg",
      "cardImage": "/images/series/InsideTheAncientWorld_CARD.jpg",
      "episodes": [
        {
          "id": "inside-the-ancient-world-s01e01",
          "number": 1,
          "season": 1,
          "title": "Builders of the Nile",
          "durationSeconds": 86,
          "assetBase": "InsideTheAncientWorld_S01E01",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E01.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "inside-the-ancient-world-s01e02",
          "number": 2,
          "season": 1,
          "title": "The Roman Machine",
          "durationSeconds": 59,
          "assetBase": "InsideTheAncientWorld_S01E02",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E02.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "inside-the-ancient-world-s01e03",
          "number": 3,
          "season": 1,
          "title": "Cities of Dust",
          "durationSeconds": 66,
          "assetBase": "InsideTheAncientWorld_S01E03",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E03.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "inside-the-ancient-world-s01e04",
          "number": 4,
          "season": 1,
          "title": "Trade Across Empires",
          "durationSeconds": 73,
          "assetBase": "InsideTheAncientWorld_S01E04",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E04.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "inside-the-ancient-world-s01e05",
          "number": 5,
          "season": 1,
          "title": "Homes of the Forgotten",
          "durationSeconds": 80,
          "assetBase": "InsideTheAncientWorld_S01E05",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E05.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E05.mp4",
          "free": false,
          "diamondCost": 4
        },
        {
          "id": "inside-the-ancient-world-s01e06",
          "number": 6,
          "season": 1,
          "title": "After the Collapse",
          "durationSeconds": 87,
          "assetBase": "InsideTheAncientWorld_S01E06",
          "thumbnail": "/images/episodes/InsideTheAncientWorld_S01E06.jpg",
          "video": "/videos/InsideTheAncientWorld_S01E06.mp4",
          "free": false,
          "diamondCost": 4
        }
      ]
    },
    {
      "id": "planet-earth-our-home",
      "title": "Planet Earth: Our Home",
      "assetSlug": "PlanetEarthOurHome",
      "genres": [
        "Documentary",
        "Science"
      ],
      "description": "A cinematic portrait of the systems that connect atmosphere, ocean, forest and life.",
      "tagline": "One planet. Countless connections.",
      "year": 2026,
      "featured": false,
      "freeEpisodeCount": 4,
      "diamondCost": 4,
      "heroImage": "/images/series/PlanetEarthOurHome_HERO.jpg",
      "cardImage": "/images/series/PlanetEarthOurHome_CARD.jpg",
      "episodes": [
        {
          "id": "planet-earth-our-home-s01e01",
          "number": 1,
          "season": 1,
          "title": "The Air Between Us",
          "durationSeconds": 83,
          "assetBase": "PlanetEarthOurHome_S01E01",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E01.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E01.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "planet-earth-our-home-s01e02",
          "number": 2,
          "season": 1,
          "title": "Ocean Engine",
          "durationSeconds": 90,
          "assetBase": "PlanetEarthOurHome_S01E02",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E02.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E02.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "planet-earth-our-home-s01e03",
          "number": 3,
          "season": 1,
          "title": "Forests That Breathe",
          "durationSeconds": 63,
          "assetBase": "PlanetEarthOurHome_S01E03",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E03.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E03.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "planet-earth-our-home-s01e04",
          "number": 4,
          "season": 1,
          "title": "Ice and Time",
          "durationSeconds": 70,
          "assetBase": "PlanetEarthOurHome_S01E04",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E04.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E04.mp4",
          "free": true,
          "diamondCost": 0
        },
        {
          "id": "planet-earth-our-home-s01e05",
          "number": 5,
          "season": 1,
          "title": "The Living Soil",
          "durationSeconds": 77,
          "assetBase": "PlanetEarthOurHome_S01E05",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E05.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E05.mp4",
          "free": false,
          "diamondCost": 4
        },
        {
          "id": "planet-earth-our-home-s01e06",
          "number": 6,
          "season": 1,
          "title": "A Shared Future",
          "durationSeconds": 84,
          "assetBase": "PlanetEarthOurHome_S01E06",
          "thumbnail": "/images/episodes/PlanetEarthOurHome_S01E06.jpg",
          "video": "/videos/PlanetEarthOurHome_S01E06.mp4",
          "free": false,
          "diamondCost": 4
        }
      ]
    }
  ]
}